module.exports = __webpack_public_path__ + "static/media/S-task15_nodeLink.6aa0bedb.png";